import cx from 'classnames'
import { take } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useContext } from 'react'
import { computed } from 'mobx'

import { AlmanacEditorStateContext } from 'stores/EditorState'
import { ReactComponent as TextColorIcon } from 'assets/icons/textColor27.svg'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import { TopTiers } from '../../Types'
import { useMobileToolbar } from '../../stores/MobileToolbarStore'

import MStyles from '../../MobileToolbar.module.scss'
import Styles from './TextColor.module.scss'

export const TextColor = observer((props: ButtonProps) => {
  const mobileToolbarStore = useMobileToolbar()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { activeColors } = useContext(AlmanacEditorStateContext)!

  const isSelected = computed(() => mobileToolbarStore.topTier === TopTiers.TextColor).get()

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Change text color"
      data-testid={`color-trigger`}
      className={cx(MStyles.button, Styles.flexCenterColumn, {
        [MStyles.buttonSelected]: isSelected,
      })}
      {...props}
    >
      <TextColorIcon />
      <ActiveColorsIndicator colors={take(activeColors, 4)} type="text" className={Styles.activeIndicator} />
    </Button>
  )
})
